// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmPropertyUnitsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AccountViewListingOptionsDto,
  AccountViewPropertyUnitsResponseDto,
  AccountViewPropertyUnitStatusDto,
  AccountViewPropertyUnitTenantsResponseDto,
  ListingAlias,
} from '../..';

interface ListParams {
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}
interface TenantsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/units/list';

/**
 * Get zrm user property table units view
 */
export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list = (
  getParams: ListParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListParams, never, AccountViewPropertyUnitsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/units/options';

/**
 * Get zrm user property table row options for a unit
 */
export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options = (
  getParams: OptionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OptionsParams, never, AccountViewListingOptionsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/units/status';

/**
 * Get zrm user property table unit status cell
 */
export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status = (
  getParams: StatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<StatusParams, never, AccountViewPropertyUnitStatusDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/units/tenants';

/**
 * Get zrm user property table tenant names for a unit
 */
export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants = (
  getParams: TenantsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TenantsParams, never, AccountViewPropertyUnitTenantsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
